// extracted by mini-css-extract-plugin
export default {"triangle":"SpXpGf","with-url":"kllxad","withUrl":"kllxad","icon":"H6UaQZ","icon-scheduled":"O_VQGl","iconScheduled":"O_VQGl"};